import { render } from "./ImageTag.vue?vue&type=template&id=219b49a4"
import script from "./ImageTag.vue?vue&type=script&lang=js"
export * from "./ImageTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__